import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AckReadySignalrBase } from '@asamco/signal-r';

export class CallContext {
	linkID: number;
	companyID: number;

	get getHeaders() {
		let headers = new HttpHeaders();
		headers = headers.set('X-Target-Backend', 'CSPPlatform');
		if (this.linkID) headers = headers.set('LinkID', `${this.linkID}`);
		const cid = this.signalRService.hubConnection?.connectionId;
		if (cid) headers = headers.set('ConnectionID', `${cid}`);
		return { headers: headers };
	}

	get postHeaders() {
		const gh = this.getHeaders;
		gh.headers = gh.headers.set('Content-Type', 'application/json');
		return gh;
	}

	get postTextHeaders() {
		const gh = this.getHeaders;
		gh.headers = gh.headers.set('Content-Type', 'text/plain');
		return gh;
	}

	constructor(public http: HttpClient, public signalRService: AckReadySignalrBase) {}
}
